import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";

const BASE = (() => {
    let url = process.env.REACT_APP_API_URL || "https://news-portal-l6pf.onrender.com";
    url = url.replace(/\/$/, "");
    if (url.endsWith("/api")) url = url.slice(0, -4);
    return url;
})();

const API_URL = `${BASE}/api/news`;

const getImageUrl = (item) => {
    const placeholder = "https://placehold.co/1200x650?text=No+Image";
    if (!item) return placeholder;

    const resolveUrl = (path) => {
        if (!path || typeof path !== "string" || path.trim() === "") return null;
        const p = path.trim();
        if (p.startsWith("http://") || p.startsWith("https://")) return p;
        if (p.startsWith("/uploads/")) return `${BASE}${p}`;
        if (p.startsWith("uploads/")) return `${BASE}/${p}`;
        if (p.includes(".")) return `${BASE}/uploads/${p}`;
        return null;
    };

    return resolveUrl(item.imagePath) || resolveUrl(item.image) || resolveUrl(item.imageUrl) || resolveUrl(item.imageURL) || resolveUrl(item.thumbnail) || placeholder;
};

const formatNewsDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "2-digit",
        year: "numeric",
    });
};

const TopNews = () => {
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchTopNews = async () => {
            setLoading(true);
            setError("");
            try {
                const response = await fetch(`${API_URL}?limit=100`);
                const result = await response.json();
                const articles = Array.isArray(result?.data) ? result.data : [];
                setNewsData(articles);
            } catch (err) {
                console.error("TopNews Fetch Error:", err);
                setError("Unable to load top news. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchTopNews();
    }, []);

    return (
        <Container className="py-4">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h2 className="mb-1">Top News</h2>
                    <p className="text-muted">Showing the latest published news sorted by newest first.</p>
                </div>
            </div>

            {loading ? null : error ? (
                <div className="alert alert-danger">{error}</div>
            ) : newsData.length === 0 ? (
                <div className="alert alert-info">No published news available yet.</div>
            ) : (
                <Row xs={1} md={2} lg={3} className="g-4">
                    {newsData.map((item) => (
                        <Col key={item._id || item.id}>
                            <Card className="h-100 shadow-sm">
                                <div className="ratio ratio-16x9 overflow-hidden">
                                    <Card.Img
                                        variant="top"
                                        src={getImageUrl(item)}
                                        alt={item.title || "Thumbnail"}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://placehold.co/1200x650?text=Image+Not+Found";
                                        }}
                                        className="object-fit-cover"
                                    />
                                </div>
                                <Card.Body className="d-flex flex-column">
                                    <Badge bg="secondary" className="mb-2 text-uppercase">
                                        {item.category || "General"}
                                    </Badge>
                                    <Card.Title>{item.title || "Untitled"}</Card.Title>
                                    <Card.Text className="text-truncate news-description">
                                        {item.shortDesc || item.description || "No description available."}
                                    </Card.Text>
                                    <div className="mt-auto text-muted small">
                                        {formatNewsDate(item.createdAt)}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default TopNews;
